/* ==========================================================================
   Quick Add - Product Card Variant Selector
   Handles popup open/close, variant option selection, availability
   filtering, and AJAX add-to-cart.
   ========================================================================== */
(function ($) {
  'use strict';

  var QuickAdd = {

    init: function () {
      this.bindEvents();
    },

    bindEvents: function () {
      $(document).on('click', '[data-quick-add-trigger]', this.handleTriggerClick.bind(this));
      $(document).on('click', '[data-quick-add-close]', this.handleClose.bind(this));
      $(document).on('click', '[data-quick-add-overlay]', this.handleClose.bind(this));
      $(document).on('click', '.quick-add-popup__option-value:not(.is-unavailable)', this.handleOptionClick.bind(this));
      $(document).on('click', '.quick-add-popup__submit:not([disabled])', this.handleSubmit.bind(this));

      // Card color swatch click — pre-select color for quick add
      $(document).on('click', '[data-quick-add-color-select]', this.handleCardColorClick.bind(this));

      // Close on Escape key
      $(document).on('keydown', function (e) {
        if (e.key === 'Escape') {
          QuickAdd.closeAll();
        }
      });
    },

    /* ------------------------------------------------------------------
       Parse variant JSON safely from data attribute
    ------------------------------------------------------------------ */
    getVariants: function ($popup) {
      var variants = $popup.data('variants');
      if (!variants) {
        // Try reading raw attribute and parsing manually
        var raw = $popup.attr('data-variants');
        if (raw) {
          try { variants = JSON.parse(raw); } catch (e) { return null; }
          $popup.data('variants', variants);
        }
      }
      if (typeof variants === 'string') {
        try { variants = JSON.parse(variants); } catch (e) { return null; }
        $popup.data('variants', variants);
      }
      return variants;
    },

    /* ------------------------------------------------------------------
       AJAX add to cart — mirrors theme's own pattern
    ------------------------------------------------------------------ */
    ajaxAddToCart: function (variantId, onSuccess, onError) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      var formData = 'form_type=product&utf8=%E2%9C%93&id=' + variantId + '&quantity=1';

      $.ajax({
        type: 'POST',
        url: root + 'cart/add.js',
        data: formData,
        dataType: 'json',
        success: function (response) {
          // Trigger theme's built-in cart update event
          $('body').trigger('ajax:addToCart', { response: response });

          // Fetch updated minicart HTML and inject into sidebar
          $.ajax({
            cache: false,
            url: root + 'cart?view=minicart',
            type: 'GET',
            dataType: 'html',
            success: function (cartHtml) {
              var $minicart = $('#js_cart_popup');
              var $cart = $(cartHtml);
              if ($cart.find('#MainContent').length) $cart = $cart.find('#MainContent');
              $minicart.html($cart);

              // Update cart count and totals
              var $jsonData = $cart.find('#json-data-cart');
              if ($jsonData.length) {
                try {
                  var data = JSON.parse($jsonData.text());
                  $('.js-cart-count').html(data.item_count);
                  if (typeof Shopify !== 'undefined' && Shopify.formatMoney && typeof theme !== 'undefined') {
                    $('.js-total-price').html(Shopify.formatMoney(data.total_price, theme.moneyFormat));
                  }
                } catch (e) {}
              }

              $('body').trigger('contentUpdated');

              // Open sidebar cart drawer
              if (!$('html').hasClass('pside_opened')) {
                $('.push_side[data-id="#js_cart_popup"]').trigger('click');
              }

              if (onSuccess) onSuccess(response);
            },
            error: function () {
              // Fallback: try theme's ShowCart if available
              if (typeof ShowCart === 'function') { ShowCart(); }
              if (!$('html').hasClass('pside_opened')) {
                $('.push_side[data-id="#js_cart_popup"]').trigger('click');
              }
              if (onSuccess) onSuccess(response);
            }
          });
        },
        error: function (xhr) {
          if (onError) onError(xhr);
        }
      });
    },

    /* ------------------------------------------------------------------
       Trigger: + ADD button clicked
    ------------------------------------------------------------------ */
    handleTriggerClick: function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $btn = $(e.currentTarget);
      var $product = $btn.closest('.product-item');
      var $popup = $product.find('[data-quick-add-popup]');

      // No variants → add to cart directly
      if (!$popup.length) {
        this.addToCartDirect($btn);
        return;
      }

      // Close any other open popups first
      this.closeAll();

      // Pre-select color if the card swatch was clicked
      var preColor = $product.data('quick-add-preselect-color');
      if (preColor) {
        var $colorGroup = $popup.find('.quick-add-popup__option-group[data-option-type="color"]');
        if ($colorGroup.length) {
          // Color group is visible in popup — pre-select it
          $colorGroup.find('.quick-add-popup__option-value').removeClass('is-selected');
          $colorGroup.find('.quick-add-popup__option-value[data-value="' + preColor + '"]').addClass('is-selected');
        } else {
          // Color group hidden from popup — store as hidden selection for variant matching
          $popup.data('hidden-color-value', preColor);
        }
        $product.removeData('quick-add-preselect-color');
        // Recalculate availability and button state
        this.updateAvailability($popup);
        this.updateSubmitButton($popup);
      }

      var isMobile = $(window).width() < 768;

      if (isMobile) {
        // Move popup to body for fixed positioning (avoids transform issues)
        $popup.data('quick-add-origin', $popup.parent());
        $popup.appendTo('body');

        // Show overlay
        var $overlay = $('#quick-add-overlay');
        if (!$overlay.length) {
          $overlay = $('<div id="quick-add-overlay" class="quick-add-overlay" data-quick-add-overlay></div>');
          $('body').append($overlay);
        }
        $overlay.addClass('is-active');
        $('body').css('overflow', 'hidden');
      } else {
        // Desktop: handle Slick carousel overflow clipping
        var $slickSlide = $product.closest('.slick-slide');
        if ($slickSlide.length) {
          $slickSlide.addClass('quick-add-overflow-visible');
          $slickSlide.closest('.slick-list').addClass('quick-add-overflow-visible');
          $popup.data('quick-add-slick-slide', $slickSlide);
        }
      }

      // Show popup
      $popup.addClass('is-active');
    },

    /* ------------------------------------------------------------------
       Card color swatch clicked (select mode, not navigate)
    ------------------------------------------------------------------ */
    handleCardColorClick: function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $swatch = $(e.currentTarget);
      var $product = $swatch.closest('.product-item');
      var colorValue = $swatch.attr('data-quick-add-color-value');

      // Visual feedback — highlight the clicked swatch on the card
      $swatch.closest('.product-options__section').find('[data-quick-add-color-select]').removeClass('active');
      $swatch.addClass('active');

      // Store pre-selected color on the product card for the popup
      $product.data('quick-add-preselect-color', colorValue);

      // Auto-open popup with pre-selected color
      $product.find('[data-quick-add-trigger]').trigger('click');
    },

    /* ------------------------------------------------------------------
       Close popup
    ------------------------------------------------------------------ */
    handleClose: function (e) {
      e.preventDefault();
      e.stopPropagation();
      this.closeAll();
    },

    closeAll: function () {
      var $activePopups = $('.quick-add-popup.is-active');

      $activePopups.each(function () {
        var $popup = $(this);

        // Restore to original parent if moved to body (mobile)
        var $origin = $popup.data('quick-add-origin');
        if ($origin && $origin.length) {
          $popup.appendTo($origin);
          $popup.removeData('quick-add-origin');
        }

        // Restore Slick overflow
        var $slickSlide = $popup.data('quick-add-slick-slide');
        if ($slickSlide && $slickSlide.length) {
          $slickSlide.removeClass('quick-add-overflow-visible');
          $slickSlide.closest('.slick-list').removeClass('quick-add-overflow-visible');
          $popup.removeData('quick-add-slick-slide');
        }

        // Clear hidden color pre-selection
        $popup.removeData('hidden-color-value');

        $popup.removeClass('is-active');
      });

      // Hide overlay
      $('#quick-add-overlay').removeClass('is-active');
      $('body').css('overflow', '');
    },

    /* ------------------------------------------------------------------
       Option value clicked
    ------------------------------------------------------------------ */
    handleOptionClick: function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $val = $(e.currentTarget);
      var $group = $val.closest('.quick-add-popup__option-group');
      var $popup = $val.closest('[data-quick-add-popup]');

      // Toggle: deselect if already selected, otherwise select
      if ($val.hasClass('is-selected')) {
        $val.removeClass('is-selected');
      } else {
        $group.find('.quick-add-popup__option-value').removeClass('is-selected');
        $val.addClass('is-selected');
      }

      // Re-evaluate availability of other options
      this.updateAvailability($popup);

      // Update submit button state
      this.updateSubmitButton($popup);
    },

    /* ------------------------------------------------------------------
       Dynamic availability: grey out values that have no matching
       available variant given the current selections in other groups.
    ------------------------------------------------------------------ */
    updateAvailability: function ($popup) {
      var variants = this.getVariants($popup);
      if (!variants) return;

      var $groups = $popup.find('.quick-add-popup__option-group');

      // Collect current selections
      var selections = {};
      $groups.each(function () {
        var idx = $(this).data('option-index');
        var $sel = $(this).find('.quick-add-popup__option-value.is-selected');
        if ($sel.length) {
          selections[idx] = String($sel.data('value'));
        }
      });

      // For each group, check each value against the OTHER selections
      $groups.each(function () {
        var currentIdx = $(this).data('option-index');

        $(this).find('.quick-add-popup__option-value').each(function () {
          var $btn = $(this);
          var testVal = String($btn.data('value'));
          var available = false;

          for (var i = 0; i < variants.length; i++) {
            var v = variants[i];
            if (!v.available) continue;

            // Must match this value at the current option position
            var optKey = 'option' + (currentIdx + 1);
            if (String(v[optKey]) !== testVal) continue;

            // Must match all OTHER selected options
            var matches = true;
            for (var key in selections) {
              if (parseInt(key) === currentIdx) continue;
              var otherKey = 'option' + (parseInt(key) + 1);
              if (String(v[otherKey]) !== String(selections[key])) {
                matches = false;
                break;
              }
            }

            if (matches) {
              available = true;
              break;
            }
          }

          if (available) {
            $btn.removeClass('is-unavailable').removeAttr('disabled aria-disabled');
          } else {
            $btn.addClass('is-unavailable').attr({ disabled: true, 'aria-disabled': 'true' });
            // If this was selected, deselect it
            if ($btn.hasClass('is-selected')) {
              $btn.removeClass('is-selected');
            }
          }
        });
      });
    },

    /* ------------------------------------------------------------------
       Submit button: disabled until ALL option groups have a selection
    ------------------------------------------------------------------ */
    updateSubmitButton: function ($popup) {
      var $groups = $popup.find('.quick-add-popup__option-group');
      var $submit = $popup.find('[data-quick-add-submit]');
      var allSelected = true;

      $groups.each(function () {
        if (!$(this).find('.quick-add-popup__option-value.is-selected').length) {
          allSelected = false;
        }
      });

      if (allSelected) {
        $submit.removeAttr('disabled').text('ADD TO BAG');
      } else {
        $submit.attr('disabled', 'disabled').text('SELECT SIZE');
      }
    },

    /* ------------------------------------------------------------------
       Submit: find matching variant, AJAX add to cart
    ------------------------------------------------------------------ */
    handleSubmit: function (e) {
      e.preventDefault();
      e.stopPropagation();

      var self = this;
      var $submit = $(e.currentTarget);
      var $popup = $submit.closest('[data-quick-add-popup]');
      var variants = this.getVariants($popup);

      if (!variants || !variants.length) return;

      // Gather all selections (visible groups)
      var selections = {};
      $popup.find('.quick-add-popup__option-group').each(function () {
        var idx = $(this).data('option-index');
        var $sel = $(this).find('.quick-add-popup__option-value.is-selected');
        if ($sel.length) {
          selections[idx] = String($sel.data('value'));
        }
      });

      // Include hidden color selection if color group was hidden but pre-selected from card swatch
      var hiddenColorIdx = $popup.attr('data-hidden-color-index');
      var hiddenColorVal = $popup.data('hidden-color-value');
      if (typeof hiddenColorIdx !== 'undefined' && hiddenColorIdx !== null && hiddenColorVal) {
        selections[parseInt(hiddenColorIdx)] = String(hiddenColorVal);
      }

      // Find the matching variant
      var matched = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var key in selections) {
          var optKey = 'option' + (parseInt(key) + 1);
          if (String(v[optKey]) !== selections[key]) {
            ok = false;
            break;
          }
        }
        if (ok) {
          matched = v;
          break;
        }
      }

      if (!matched || !matched.available) return;

      // Disable button and show loading
      $submit.attr('disabled', 'disabled').text('ADDING...').addClass('is-adding');

      this.ajaxAddToCart(matched.id,
        function () {
          $submit.text('ADDED!').removeClass('is-adding');
          // Reset and close after brief feedback
          setTimeout(function () {
            self.closeAll();
            $popup.find('.quick-add-popup__option-value').removeClass('is-selected');
            $submit.attr('disabled', 'disabled').text('SELECT SIZE');
          }, 1200);
        },
        function () {
          $submit.removeClass('is-adding').text('ERROR — TRY AGAIN');
          setTimeout(function () {
            $submit.removeAttr('disabled').text('ADD TO BAG');
          }, 2000);
        }
      );
    },

    /* ------------------------------------------------------------------
       Direct add-to-cart (single variant / default variant products)
    ------------------------------------------------------------------ */
    addToCartDirect: function ($btn) {
      var pid = $btn.data('pid');
      if (!pid) return;

      var originalHTML = $btn.html();
      $btn.addClass('quick-add-loading').html('ADDING...');

      this.ajaxAddToCart(pid,
        function () {
          $btn.removeClass('quick-add-loading').html('ADDED!');
          setTimeout(function () {
            $btn.html(originalHTML);
          }, 1200);
        },
        function () {
          $btn.removeClass('quick-add-loading').html(originalHTML);
        }
      );
    }
  };

  // Initialize on DOM ready
  $(function () {
    QuickAdd.init();
  });

})(jQuery);
